const SET_TRACKING_CODE = 'SET_TRACKING_CODE';
const GET_TRACKING_CODE = 'GET_TRACKING_CODE';
const SET_CHARITY_LOGO = 'SET_CHARITY_LOGO';
const SET_CHARITY_NAME = 'SET_CHARITY_NAME';
const IS_EXTENSION_INSTALLED = 'IS_EXTENSION_INSTALLED';

const extensionID = 'djidapogageiehhmihamgimggepbnojp';
// const sfExtensionID = "com.givebacks.mac.Extension (team_identifier)";
const sfExtensionID = 'Wildfire-Systems.Givebacks-DSE.Extension (UNSIGNED)';

const MULTI_CAUSE_IMG =
  'https://s3.amazonaws.com/com.givebacks.public/images/extensions/your_favorite_causes.png';

const chromeMessenger = async (payload: any) => {
  return new Promise<void>((resolve, reject) => {
    window.chrome.runtime.sendMessage(extensionID, payload, (msg: any) => {
      if (!msg) {
        return reject('No response from Chrome Extension');
      }
      return resolve(msg);
    });
  });
};
const safariMessenger = async (payload: any) => {
  return new Promise((resolve, reject) => {
    // When Safari Messenger becomes it's own thing', we'll devote time to fixing this error
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    browser?.runtime.sendMessage(sfExtensionID, payload, (msg: any) => {
      if (!msg) {
        return reject('No response from Safari Extension');
      }
      return resolve(msg);
    });
  });
};

const sendMessage = async (payload: any) => {
  try {
    if (window?.chrome?.runtime) {
      const res = await chromeMessenger(payload);
      return res;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
    } else if (browser && browser.runtime) {
      const res = await safariMessenger(payload);
      return res;
    } else {
      throw new Error('No suitable runtime found');
    }
  } catch (e) {
    throw new Error(`Error sending message: ${e}`);
  }
};

const isInstalled = () => {
  return sendMessage({ status: IS_EXTENSION_INSTALLED });
};

const getTrackingCode = () => {
  return sendMessage({ status: GET_TRACKING_CODE });
};

const syncCharityLogo = (url: string) => {
  return sendMessage({ status: SET_CHARITY_LOGO, payload: url });
};

const syncCharityName = (name: string) => {
  return sendMessage({ status: SET_CHARITY_NAME, payload: name });
};

const setTrackingCode = (user: any) => {
  return sendMessage({ status: SET_TRACKING_CODE, payload: { code: user.uuid } });
};

const syncCause = async (causes: any[]) => {
  try {
    if (causes?.length === 1) {
      const cause = causes?.[0] || {};
      const { name, thumbnail } = cause;
      const { url } = thumbnail || {};
      await syncCharityLogo(url || '');
      await syncCharityName(name || '');
    } else {
      await syncCharityLogo(MULTI_CAUSE_IMG);
      await syncCharityName('your favorite causes');
    }
  } catch (e) {
    throw new Error(`Error syncing cause: ${e}`);
  }
};

const setUser = async (user: any) => {
  try {
    await syncCause(user.selected_causes);
    await setTrackingCode(user);
    return await getTrackingCode();
  } catch (e) {
    throw new Error(`Error setting user: ${e}`);
  }
};

const download = () => {
  const url = `https://chrome.google.com/webstore/detail/givebacks/${extensionID}`;
  window.location.href = url;
};

const chromeExtension = () => {};
export default chromeExtension;
chromeExtension.download = download;
chromeExtension.setUser = setUser;
chromeExtension.setTrackingCode = setTrackingCode;
chromeExtension.isInstalled = isInstalled;
